import {
  initializeWidgetConfiguration,
  SgWidget,
  WidgetConfigurationProvider,
  WithGlobalCss,
} from "@sgwt-widget/core";
import { h } from "preact";
import { emit, props } from "skatejs";
import WidgetTracker from "../common/components/WidgetTracker/WidgetTracker";
import { IClientAccount } from "../common/utils/types";
import { PortfolioClientList } from "./components/PortfolioClientList";
import {
  AgGridUserPreference,
  UserSelection,
} from "../common/sg-dashboard/userPreference/userPreference.typings";
import { saveUserPreferences } from "../common/sg-dashboard/userPreference/userpreference";
import { MapToAgGridUserPreference } from "../common/sg-dashboard/userPreference/userpreference.map";
import { ObsoleteWidgetMessage } from "../common/utils/ObsoleteWidgetMessage";

interface IProps {
  attribute?: string;
  filters?: { [attribute: string]: string[] | string | IClientAccount[] };
  userSelection: UserSelection;
  userEmail?: string;
}

class CprPortfolioClientList extends SgWidget<IProps> {
  public static is = "cpr-portfolio-client-list";

  public static props = {
    attribute: props.string,
    filters: props.object,
    userEmail: props.string,
    userSelection: props.object,
  };

  public render(intraprops: IProps) {
    if (intraprops.attribute && intraprops.attribute === "client_grpname") {
      CprPortfolioClientList.is = "cpr-portfolio-client-list--clientgroup";
    }
    if (intraprops.attribute && intraprops.attribute === "clientgen_id") {
      CprPortfolioClientList.is = "cpr-portfolio-client-list--clientsnapshot";
    }

    const headers = { uiscreen: CprPortfolioClientList.is };
    const onColumnsMoved = (value: AgGridUserPreference) => {
      intraprops.userSelection = value;
      if (
        intraprops.attribute &&
        intraprops.attribute === "client_corigrpcomid"
      ) {
        saveUserPreferences(
          this,
          [
            "cpr-portfolio-client-list--portfolio--order-changed",
            "cpr-portfolio-client-list--order-changed",
            "cpr-portfolio-client-list-columns--order-changed",
          ],
          value
        );
      } else if (
        intraprops.attribute &&
        intraprops.attribute === "clientgen_id"
      ) {
        saveUserPreferences(
          this,
          [
            "cpr-portfolio-client-list--clientsnapshot--order-changed",
            "cpr-portfolio-client-list--order-changed",
            "cpr-portfolio-client-list-columns--order-changed",
          ],
          value
        );
      } else {
        saveUserPreferences(
          this,
          ["cpr-portfolio-client-list--clientgroup--order-changed"],
          value
        );
      }
    };
    return (
      <WidgetConfigurationProvider
        widgetConfiguration={this.widgetConfiguration}
      >
        <WithGlobalCss>
          <ObsoleteWidgetMessage
            newWidgetId={
              CprPortfolioClientList.is ===
              "cpr-portfolio-client-list--clientsnapshot"
                ? 3910
                : 2624
            }
          />
          <PortfolioClientList
            filters={this.props.filters}
            headers={headers}
            attribute={this.props.attribute}
            onColumnsMoved={onColumnsMoved}
            userSelection={MapToAgGridUserPreference(intraprops.userSelection)}
          />
          <WidgetTracker widgetName={CprPortfolioClientList.is} />
        </WithGlobalCss>
      </WidgetConfigurationProvider>
    );
  }
}

initializeWidgetConfiguration(CprPortfolioClientList, {
  disablejQuerySanityCheck: true,
  neverUseShadowDOM: true,
});
customElements.define(CprPortfolioClientList.is, CprPortfolioClientList);
